import React from 'react'

import * as S from './ConversionRateReportCardLabel.styled'

type ConversionRateReportCardLabelProps = {
  label: string
  sessionsNumber: number
}

export const ConversionRateReportCardLabel = ({
  label,
  sessionsNumber,
}: ConversionRateReportCardLabelProps) => {
  return (
    <S.Container>
      <S.Label>{label}</S.Label>
      <S.Sublabel>{sessionsNumber} sessions</S.Sublabel>
    </S.Container>
  )
}
